module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-overlay"
  }, [_c('div', {
    staticClass: "popup",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.popupBezar
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h1', [_vm._v("Pontszámok")]), _vm._v(" "), (_vm.pontok.length > 0) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n        Rendszeres szociális támogatás és költségtérítés mérséklésre beadott pályázatának bírálati pontszámai.\n      ")]), _vm._v(" "), _vm._l((_vm.pontok), function(pont, i) {
    return _c('div', {
      staticClass: "point-row"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n          " + _vm._s(pont.kategoria) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "point"
    }, [_vm._v("\n          " + _vm._s(pont.pontszam) + "\n        ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "point-row sum"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n          Összpontszám\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }, [_vm._v("\n          " + _vm._s(_vm.osszpontszam) + "\n        ")])])], 2) : _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_vm._v("\n      Nem található bírálati pontszám.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11485c17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendszeres_szocialis_pontok.vue
// module id = 325
// module chunks = 0